/**
 * **누르자마자 휴대폰 키보드를 띄운다** (사용자 2026-10-27 "몬스터박스 + 누르면 바로 키보드 창").
 *
 * 아이폰 사파리는 사용자가 누른 그 처리(클릭 핸들러) 안에서 입력칸에 focus 해야만 키보드를 연다. 그런데 검색칸은 누른 뒤
 * React 가 창을 그려야 생기므로 그때 focus 하면 이미 늦다 — 키보드 없이 커서만 깜빡인다.
 * 그래서 누른 순간 화면 밖 숨은 입력칸에 먼저 focus 해서 키보드를 열어 두고, 창이 뜨면 진짜 검색칸으로 focus 를 옮긴다
 * (키보드가 열린 채 focus 를 옮기면 닫히지 않는다). 숨은 칸은 한 번만 만들어 두고 다시 쓴다.
 */
let proxy: HTMLInputElement | null = null;

export function primeKeyboard() {
    if (!proxy) {
        proxy = document.createElement('input');
        proxy.type = 'text';
        proxy.setAttribute('aria-hidden', 'true');
        proxy.tabIndex = -1;
        // 16px 이상이어야 아이폰이 focus 때 화면을 확대하지 않는다
        Object.assign(proxy.style, { position: 'fixed', top: '0', left: '0', width: '1px', height: '1px', opacity: '0', fontSize: '16px', border: '0', padding: '0' });
        document.body.appendChild(proxy);
    }
    proxy.focus({ preventScroll: true });
}
